const selectionSliderElem = document.querySelectorAll('[data-slider="selection-slider"]');

const selectionSliderOptions = {
  watchOverflow: true,
  spaceBetween: 8,
  speed: 500,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  allowTouchMove: false,
};

selectionSliderElem.forEach((el) => {
  const parent = el.closest('.selection-slider');
  const arrowLeft = parent.querySelector('.swiper-button-prev');
  const arrowRight = parent.querySelector('.swiper-button-next');
  const activeItems = parent.querySelector('.active-slide');

  selectionSliderOptions.navigation.prevEl = arrowLeft;
  selectionSliderOptions.navigation.nextEl = arrowRight;

  const selectionSlider = new Swiper(el, selectionSliderOptions);

  if (activeItems) {
    const activeIndex = activeItems.getAttribute('data-slide');
    selectionSlider.slideTo(activeIndex, 0);
  }
});
